<form class="finding-edit-form" *ngIf="finding" [formGroup]="findingForm" novalidate>


  <mat-form-field class="finding-edit-form--title">
    <input matInput placeholder="Finding Title" formControlName="title" [readonly]="!isNew" />
    <mat-error *ngIf="findingForm.get('title').hasError('exists')">
      This finding title already exists in this Audit
    </mat-error>
    <mat-error *ngIf="findingForm.get('title').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="finding-edit-form--due-date">
    <input matInput formControlName="dueDate" 
        placeholder="Evidence Approval Due Date" 
        [min]="today" 
        [matDatepicker]="dueDateDatePicker" 
        [max]="maxDate"
        readonly />
    <mat-datepicker-toggle matSuffix [for]="dueDateDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #dueDateDatePicker></mat-datepicker>
    <mat-error *ngIf="findingForm.get('dueDate').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="finding-edit-form--code">
    <input matInput placeholder="Finding Code (optional)" formControlName="code" />
  </mat-form-field>

  <mat-form-field class="finding-edit-form--owners">
    <mat-select formControlName="owners" placeholder="Deviation Owners" [multiple]="true" #owners>
      <mat-option>

      <ngx-mat-select-search formControlName="ownersFilter" [searching]="searching"
      [placeholderLabel]="'Find Employee...'" 
      [noEntriesFoundLabel]="'No employee found'"></ngx-mat-select-search>
      </mat-option>

    <mat-option *ngFor="let emp of filteredOwners | async" [value]="emp">
        {{emp.fullName}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="finding-edit-form--description">
    <textarea matInput #description rows="3" placeholder="Finding Description" formControlName="description"></textarea>
    <mat-hint align="end">{{ description.value.length || 0 }} / 2000</mat-hint>
    <mat-error *ngIf="findingForm.get('description').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

</form>